<template>
  <content>
    <app-header />
    <app-scroll-to-top />

    <div class="section-fullscreen bg-image" style="background-image: url(images/belly.jpg)">
      <div class="bg-white-04">
        <div class="container">
          <div class="position-middle">
            <div class="row">
              <div class="col-12 col-sm-10 col-md-8 col-lg-6">
                <h4>Coming Soon!</h4>
                <p
                  class="margin-bottom-20"
                >Platform voor zwangere vrouwen. Samen met je geboortepartner in vol vertrouwen toeleven naar de geboorte van je baby.</p>
                <div class="scrolltohypnobirthing">
                  <a class="button button-lg button-cta button-radius" href="#">
                    <span>Op zoek naar een cursus Hypnobirthing?</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="hypnobirthing" class="section-lg">
      <div class="container">
        <!-- <div class="row margin-bottom-30">

          <div class="col-12 col-md-12 col-lg-12">
            <h2>Hypnobirthing cursus volgen?</h2>
          </div>
        </div>-->

        <div class="row text-center">
          <div class="col-12 col-md-6 col-lg-6">
            <div class="border-all border-radius padding-30">
              <div class="margin-top-30">
                <!-- <p class="margin-bottom-30">
                  <a href="https://www.puur-zwanger.nl/"><span class="puurzwanger uppercase">Puur Zwanger</span></a>
                </p>-->
                <h4>
                  <a href="https://www.puur-zwanger.nl/" class="hyperlink-5">PUUR Zwanger</a>
                </h4>
                <p class="font-weight-normal">Gaby van Mierle</p>
                <p>
                  <a href="mailto:gaby@puur-zwanger.nl" class="hyperlink-5">gaby@puur-zwanger.nl</a>
                </p>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-6">
            <div class="border-all border-radius padding-30">
              <div class="margin-top-30">
                <!-- <p class="margin-bottom-30">
                  <a href="https://heybabycoaching.nl/"><img src="images/heybaby_logo_blue.svg" /></a>
                </p>-->
                <h4>
                  <a href="https://heybabycoaching.nl/" class="hyperlink-5">Hey Baby Coaching</a>
                </h4>
                <p class="font-weight-normal">Marijn van der Zwaard</p>
                <p>
                  <a
                    href="mailto:marijn@heybabycoaching.nl"
                    class="hyperlink-5"
                  >marijn@heybabycoaching.nl</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-footer />
  </content>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import AppScrollToTop from "@/components/AppScrollToTop";
import AppFooter from "@/components/AppFooter";

import JQuery from "jquery";
import "jquery.easing";
const $ = JQuery;

export default {
  components: {
    AppHeader,
    AppScrollToTop,
    AppFooter
  },
  mounted() {
    /*===============================================
      Scroll to hypnobirthing section
    ===============================================*/

    const scrollBtn = $(".scrolltohypnobirthing");
    const htmlBody = $("html,body");
    scrollBtn.on("click", function() {
      htmlBody.animate(
        { scrollTop: $("#hypnobirthing").offset().top },
        600,
        "easeInOutQuart"
      );
      return false;
    });
  }
};
</script>

<style lang="scss">
@import '../assets/mono/css/scss/_variables.scss';

.button-cta, a.button-cta {
	background: #663399; 
	border-color: #663399;
	color: $color-white;
	&:hover, &:focus {
		background:#8A2BE2;
		border-color: #663399;
		color: $color-white;
	}
}


</style>